import { DataGridWithCheckbox, mergeSx, type DataGridWithCheckboxProps } from '@shared/components';

import { columns } from './columns';

export type ExamineeTimeExtensionDataGridProps = Omit<DataGridWithCheckboxProps, 'columns'>;

export default function ExamineeTimeExtensionDataGrid(
  props: Readonly<ExamineeTimeExtensionDataGridProps>,
) {
  const { rows, sx, ...restProps } = props;
  return (
    <DataGridWithCheckbox
      {...restProps}
      disableColumnMenu
      rows={rows}
      columns={columns}
      hideFooter={rows.length === 0}
      rowHeight={48}
      sx={mergeSx(
        (theme) => ({
          '--DataGrid-overlayHeight': '124px',
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            p: theme.spacing(2.5, 3),
          },
          '& .MuiButtonBase-root': {
            p: 0,
          },
          '& .MuiCheckbox-root': {
            color: theme.palette.grey[400],
            p: 0,
            '&.Mui-checked': {
              color: theme.palette.primary.main,
            },
          },
          '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          // Style override for Footer
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sx,
      )}
    />
  );
}
